import { Component, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-switch-text',
  templateUrl: './switch-text.component.html',
  styleUrls: ['./switch-text.component.scss']
})
export class SwitchTextComponent extends ComponentBase implements OnInit  {

  valueChange: boolean = true;
  isChecked: boolean = true;
  textNotChecked: string = "Sem conteúdo";

  constructor() { super() }

  ngOnInit() {
    this.valueChange = (this.attribute.value != null || this.attribute.value != '') ? true : false;

    this.configureIsChecked();

  }

  onValueChange(value: boolean) {
    this.valueChange = value;
    this.attribute.value = null;
  }

  private configureIsChecked() {

    if (!this.attribute.value) {
      
      let checkedByDefault = this.getOptionByKey(this.attribute, "CheckedByDefault");

      if (checkedByDefault != null && checkedByDefault != '') {

        if (checkedByDefault.toUpperCase() == "TRUE")
          this.isChecked = true;
        else
          this.isChecked = false;

          this.onValueChange(this.isChecked);
      }
    }

    let _textNotChecked = this.getOptionByKey(this.attribute, "TextNotChecked");

    if (_textNotChecked != null && _textNotChecked != '')
      this.textNotChecked = _textNotChecked;
  }
 
}
